import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, LayoutDashboard, Rocket, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface OnboardingChoiceModalProps {
  open: boolean;
  onChoice: (choice: 'wizard' | 'dashboard') => void;
}

export function OnboardingChoiceModal({ open, onChoice }: OnboardingChoiceModalProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-[550px] p-0 overflow-hidden border-none shadow-2xl">
        <div className="bg-gradient-to-br from-primary/10 via-background to-background p-8">
          <DialogHeader className="items-center text-center space-y-4">
            <div className="h-16 w-16 bg-primary/10 rounded-2xl flex items-center justify-center animate-bounce">
              <Rocket className="h-8 w-8 text-primary" />
            </div>
            <div className="space-y-2">
              <DialogTitle className="text-3xl font-bold text-foreground">
                Selamat Datang di Chatbaze!
              </DialogTitle>
              <DialogDescription className="text-base text-muted-foreground">
                Kami lihat Anda belum memiliki website. Mari mulai dengan cara terbaik untuk Anda.
              </DialogDescription>
            </div>
          </DialogHeader>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
            {/* Wizard Choice */}
            <button
              onClick={() => onChoice('wizard')}
              className={cn(
                "group relative flex flex-col items-center p-6 rounded-2xl border-2 transition-all text-center",
                "bg-card border-primary/20 hover:border-primary hover:shadow-xl hover:shadow-primary/5",
                "active:scale-95"
              )}
            >
              <div className="absolute -top-3 -right-3 bg-primary text-white text-[10px] font-bold px-2 py-1 rounded-full flex items-center gap-1 shadow-lg">
                <Sparkles className="h-3 w-3" />
                DIPILIH
              </div>
              <div className="h-12 w-12 rounded-xl bg-primary flex items-center justify-center mb-4 transition-transform group-hover:rotate-12 group-hover:scale-110">
                <Rocket className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-bold text-lg mb-1">Ikuti Wizard</h3>
              <p className="text-xs text-muted-foreground px-2">
                Panduan langkah demi langkah untuk setup chatbot dalam 10 menit.
              </p>
              <div className="mt-4 flex flex-col gap-2 w-full text-[10px] text-left">
                <div className="flex items-center gap-2 text-emerald-600 font-medium">
                  <CheckCircle2 className="h-3 w-3" /> Verifikasi Domain
                </div>
                <div className="flex items-center gap-2 text-emerald-600 font-medium">
                  <CheckCircle2 className="h-3 w-3" /> Isi Knowledge Base
                </div>
                <div className="flex items-center gap-2 text-emerald-600 font-medium">
                  <CheckCircle2 className="h-3 w-3" /> Pasang Script Widget
                </div>
              </div>
            </button>

            {/* Manual Choice */}
            <button
              onClick={() => onChoice('dashboard')}
              className={cn(
                "group flex flex-col items-center p-6 rounded-2xl border-2 transition-all text-center",
                "bg-muted/30 border-transparent hover:bg-muted/50 hover:border-muted-foreground/20",
                "active:scale-95"
              )}
            >
              <div className="h-12 w-12 rounded-xl bg-muted-foreground/10 flex items-center justify-center mb-4 transition-transform group-hover:-rotate-12 group-hover:scale-110">
                <LayoutDashboard className="h-6 w-6 text-muted-foreground" />
              </div>
              <h3 className="font-bold text-lg mb-1">Masuk Dashboard</h3>
              <p className="text-xs text-muted-foreground px-2">
                Eksplorasi sendiri semua fitur Chatbaze secara manual.
              </p>
              <div className="mt-auto pt-6 flex w-full justify-center">
                 <span className="text-[10px] text-muted-foreground hover:underline italic">Saya sudah mengerti navigasi dashboard</span>
              </div>
            </button>
          </div>

          <div className="mt-10 text-center">
            <p className="text-[10px] text-muted-foreground">
              Anda selalu dapat mengakses menu pengaturan secara mandiri nanti.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
